import styled from 'styled-components';
import { useAppDispatch } from '../../../../redux/hooks';
import { setActiveThread } from '../../../../redux/slices/conversationThreads';
import { IConversationThreadFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import KubitTooltip from '../../../KubitTooltip';
import { SvgIcon } from '../../../Icon';
import EntityConversationThreadsPagination from './EntityConversationThreadsPagination';

interface IProps {
  activeThreadIndex: number;
  threads: IConversationThreadFieldsFragment[];
  onResolve: () => Promise<void>;
  onDismiss: () => void;
}

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
`;
const HeaderActions = styled.div`
  flex: 0 0 auto;
  display: flex;
  column-gap: 4px;
`;

const EntityConversationThreadsHeader = ({
  activeThreadIndex,
  threads,
  onResolve,
  onDismiss,
}: IProps) => {
  const dispatch = useAppDispatch();
  const handlePreviousThread = () => {
    dispatch(setActiveThread(threads[activeThreadIndex - 1]));
  };
  const handleNextThread = () => {
    dispatch(setActiveThread(threads[activeThreadIndex + 1]));
  };

  return (
    <Header>
      <EntityConversationThreadsPagination
        activeIndex={activeThreadIndex}
        amountOfThreads={threads.length}
        onPreviousClick={handlePreviousThread}
        onNextClick={handleNextThread}
      />
      <HeaderActions>
        <KubitTooltip
          content={'Resolve Conversation'}
          placement="top"
          noOpenDelay={true}
        >
          <SvgIcon
            name="check-circle"
            width={24}
            height={24}
            onClick={onResolve}
            isHoverable={true}
          />
        </KubitTooltip>
        <KubitTooltip
          content={'Close Conversation'}
          placement="top"
          noOpenDelay={true}
        >
          <SvgIcon
            name="icon-x"
            width={24}
            height={24}
            onClick={onDismiss}
            isHoverable={true}
          />
        </KubitTooltip>
      </HeaderActions>
    </Header>
  );
};

export default EntityConversationThreadsHeader;
